const eventKindTypeIconCode: Record<number, number> = {
    0x0002: 1,
    0x0260: 1,
    0x0270: 1,
    0x0003: 2,
    0x0001: 3,
    0x000D: 4,
    0x0010: 5,
    0x0013: 7,
    0x0058: 6,
    0x0009: 11,
    0x0266: 11,
    0x0276: 11,
    0x0012: 12,
    0x0026: 13,
    0x0038: 14,
    0x0057: 15,
    0x0066: 15,
    0x0020: 21,
    0x0030: 22,
    0x0031: 23,
    0x0032: 24,
    0x0050: 25,
    0x0060: 25,
    0x0051: 26,
    0x0004: 30,
    0x0021: 30,
    0x0033: 30,
    0x0052: 30,
    0x0061: 30,
    0x0261: 30,
    0x0271: 30,
    0x0005: 31,
    0x0022: 31,
    0x0034: 31,
    0x0053: 31,
    0x0062: 31,
    0x0262: 31,
    0x0272: 31,
    0x0071: 32,
    0x0091: 32,
    0x00A2: 32,
    0x00B1: 32,
    0x00C1: 32,
    0x0072: 33,
    0x0092: 33,
    0x00A3: 33,
    0x00B2: 33,
    0x00C2: 33,
    0x0006: 40,
    0x0023: 40,
    0x0035: 40,
    0x0054: 40,
    0x0063: 40,
    0x0073: 40,
    0x0093: 40,
    0x0263: 40,
    0x0273: 40,
    0x00A4: 40,
    0x00B3: 40,
    0x00C3: 40,
    0x0007: 41,
    0x0024: 41,
    0x0036: 41,
    0x0055: 41,
    0x0064: 41,
    0x0264: 41,
    0x0274: 41,
    0x00A5: 41,
    0x00B4: 41,
    0x00C4: 41,
    0x000B: 42,
    0x000C: 43,
    0x000E: 44,
    0x000F: 45,
    0x0075: 46,
    0x0095: 46,
    0x00B6: 46,
    0x0008: 50,
    0x0025: 50,
    0x0037: 50,
    0x0056: 50,
    0x0065: 50,
    0x0265: 50,
    0x0275: 50,
    0x000A: 51,
    0x0074: 52,
    0x0094: 52,
    0x00A6: 52,
    0x00B5: 52,
    0x00C5: 52,
    0x0070: 60,
    0x0090: 61,
    0x00A0: 62,
    0x00A1: 63,
    0x00A7: 64,
    0x00A8: 65,
    0x00A9: 66,
    0x00B0: 67,
    0x00C0: 67,
    0x00B7: 68,
    0x0076: 70,
    0x0077: 71,
    0x0078: 72,
    0x0079: 73,
    0x007A: 74,
    0x007B: 75,
    0x00B8: 76,
    0x00B9: 77,
    0x00D0: 80,
    0x00D1: 81,
    0x00E1: 225,
    0x00E2: 226,
    0x00E3: 227,
    0x00E4: 228,
    0x00E5: 229,
    0x00E6: 230,
    0x00E7: 231,
    0x00E8: 232,
    0x00E9: 233,
    0x00EA: 234,
    0x00EB: 235,
    0x00EC: 236,
    0x00ED: 237,
    0x00EE: 238,
    0x00EF: 239,
    0x00F0: 240,
    0x00F1: 241,
    0x00F2: 242,
    0x00F3: 243,
    0x00F4: 244,
    0x00F5: 245,
    0x00F6: 246,
    0x00F7: 247,
    0x00F8: 248,
    0x00F9: 249,
    0x00FA: 250,
    0x00FB: 251,
    0x00FC: 252,
    0x00FD: 253,
    0x00FE: 254,
    0x00FF: 255,
    0x0100: 256,
    0x0101: 257,
    0x0102: 258,
    0x0103: 259,
    0x0104: 260,
    0x0105: 261,
    0x0106: 262,
    0x0107: 263,
    0x0108: 264,
    0x0109: 265,
    0x010A: 266,
    0x010B: 267,
    0x010C: 268,
    0x010D: 269,
    0x010E: 270,
    0x010F: 271,
    0x0110: 272,
    0x0111: 273,
};

export const lookupIconCode = (eventKindType: number) => eventKindTypeIconCode[eventKindType] || 0;
